import React, { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { currentTheme, toggleTheme } from "@/lib/theme";

// Single toggle used everywhere — app NavHeader AND the public pages (Landing/Login) — so the control
// is present no matter where the user is, signed in or out.
export default function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState(currentTheme());
  const isDark = theme === "dark";
  return (
    <button
      onClick={() => setTheme(toggleTheme())}
      data-theme-toggle=""
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Light theme" : "Dark theme"}
      className={`w-10 h-10 sm:w-8 sm:h-8 rounded-md flex items-center justify-center text-ink-3 hover:text-ink hover:bg-elevated cursor-pointer border-none bg-transparent ${className}`}
    >
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
